import React from 'react';
import { Chip, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { withFormsy } from 'formsy-react';

function AutocompleteFormsy(props) {
    const { options, label, name, required, disabled, className, placeholder, variant = 'outlined' } = props;
    const errorMessage = props.isPristine && !props.isFormSubmitted ? null : props.errorMessage;
    const selected = (props.value || []).map((value) => options.find((option) => option.value === value)).filter(Boolean);

    const changeValue = (event, selectedOptions) => {
        props.setValue(selectedOptions.map((option) => option.value));
        if (props.onChange) {
            props.onChange(event, selectedOptions);
        }
    };

    return (
        <Autocomplete
            multiple
            disableCloseOnSelect
            className={className}
            options={options}
            value={selected}
            onChange={changeValue}
            disabled={disabled}
            getOptionLabel={(option) => option.label}
            getOptionSelected={(option, value) => option.value === value.value}
            renderTags={(tagValue, getTagProps) => tagValue.map((option, index) => <Chip key={option.value} label={option.label} size="small" {...getTagProps({ index })} />)}
            renderInput={(params) => <TextField {...params} name={name} label={label} placeholder={placeholder} variant={variant} InputLabelProps={{ ...params.InputLabelProps, required }} error={Boolean(errorMessage)} helperText={errorMessage} />}
        />
    );
}

export default React.memo(withFormsy(AutocompleteFormsy));
